import { useHistory } from "react-router-dom";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useState } from "react";
// import { getSession } from "../../../redux/actions/authActions";
import { useSelector } from "react-redux";

export const TransactionHistory = ({
  showAll = false,
  redirectionUrl = "/dashboard",
  // userId = false,
}) => {
  const history = useHistory();
  // const { user_profile_id } = getSession();
  // const id = userId ? userId : user_profile_id;
  const { recentTransactions, isLoadingRecentTransactions } = useSelector(
    (state) => state.wallet
  );

  // const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("weekly");
  const [amountFilter, setAmountFilter] = useState("all");

  const filteredTransactions = recentTransactions
    .filter((tx) => {
      const transactionDate = new Date(tx.timestamp);
      const today = new Date();

      if (filter === "today") {
        return transactionDate.toDateString() === today.toDateString();
      } else if (filter === "weekly") {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return transactionDate >= oneWeekAgo;
      } else if (filter === "month") {
        return (
          transactionDate.getMonth() === today.getMonth() &&
          transactionDate.getFullYear() === today.getFullYear()
        );
      }
      return true;
    })
    .filter((tx) => {
      if (amountFilter === "credit") {
        return tx.transaction_type === "credit";
      } else if (amountFilter === "debit") {
        return tx.transaction_type === "debit";
      }
      return true;
    });

  const totalAmount = filteredTransactions.reduce(
    (acc, tx) => acc + parseFloat(tx.amount),
    0
  );

  return (
    <>
      {showAll && (
        <Header
          pageTitle="Wallet > Transaction History"
          icon={
            <Icon icon="material-symbols-light:account-balance-wallet-outline" />
          }
        />
      )}
      <div>
        <div
          className={`flex justify-between items-center sticky bg-white p-3 md:p-4 pb-1 ${
            showAll ? "!sm:relative !sm:top-0 !sticky !top-16" : ""
          }`}
        >
          <h2 className="text-xl md:text-2xl font-bold">eTransactions</h2>
          {!showAll && (
            <button
              onClick={() => history.push(redirectionUrl)}
              className="text-blue-700 hover:underline font-semibold text-xs md:text-base"
            >
              Show All
            </button>
          )}
        </div>
        {!showAll ? null : (
          <div className="py-2 flex gap-4 items-center justify-between">
            <div className="flex gap-2 px-4">
              <button
                className={`px-4 py-2 rounded-lg ${
                  filter === "today" ? "bg-blue-500 text-white" : "bg-gray-200"
                }`}
                onClick={() => setFilter("today")}
              >
                Today
              </button>
              <button
                className={`px-4 py-2 rounded-lg ${
                  filter === "weekly" ? "bg-blue-500 text-white" : "bg-gray-200"
                }`}
                onClick={() => setFilter("weekly")}
              >
                This Week
              </button>
              <button
                className={`px-4 py-2 rounded-lg ${
                  filter === "month" ? "bg-blue-500 text-white" : "bg-gray-200"
                }`}
                onClick={() => setFilter("month")}
              >
                This Month
              </button>
            </div>
            <div className="flex gap-4 items-center px-4">
              <select
                className="p-2 border rounded-lg"
                value={amountFilter}
                onChange={(e) => setAmountFilter(e.target.value)}
              >
                <option value="all">All Transactions</option>
                <option value="credit">Credited</option>
                <option value="debit">Debited</option>
              </select>
              <div className="text-lg font-semibold text-gray-700">
                <p className="mb-0">
                  Total :{" "}
                  <span
                    className={
                      amountFilter === "debit" || totalAmount.toFixed(2) < 0
                        ? "text-red-600"
                        : "text-green-600"
                    }
                  >
                    ${totalAmount.toFixed(2)}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
        {isLoadingRecentTransactions ? (
          <p className="text-center py-4">Loading...</p>
        ) : (
          <ul className="px-3 md:px-4 flex flex-col gap-1">
            {filteredTransactions.length > 0 ? (
              filteredTransactions.map((tx) => (
                <li
                  key={tx.id}
                  className="py-4 flex justify-between items-center transition-all hover:bg-blue-200 px-4 rounded-lg shadow-sm"
                >
                  <div>
                    <span className="text-gray-800 font-semibold">
                      {tx.transaction_source
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
                      ({new Date(tx.timestamp).toLocaleString()})
                    </span>
                    <p className="text-xs text-gray-400 font-semibold mb-0">
                      Status: {tx.status}
                    </p>
                  </div>
                  <span
                    className={
                      tx.transaction_type === "credit"
                        ? "text-green-600 font-bold"
                        : "text-red-600 font-bold"
                    }
                  >
                    {tx.transaction_type === "credit" ? "+$" : "-$"}
                    {parseFloat(tx.amount).toFixed(2)}
                  </span>
                </li>
              ))
            ) : (
              <p className="text-center py-4">No transactions found.</p>
            )}
          </ul>
        )}
      </div>
    </>
  );
};
